/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2025-04-08 15:11:59
 * @FilePath: \crane-safety-manager\src\slices\auth\login\thunk.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { APIClient } from '../../../helpers/api_helper';

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';

export const loginUser = (user, history) => async dispatch => {
    try {
        const payload = { username: user.username, password: user.password };
        const { data } = await APIClient.post('/auth/signin', payload);
        if (data) {
            localStorage.setItem('authUser', JSON.stringify(data));
            dispatch(loginSuccess(data));
            history('/');
        }
    } catch (error) {
        const errorMessage = error.response?.data || '登录失败，请稍后重试';
        dispatch(apiError(errorMessage));
    }
};

export const logoutUser = () => async dispatch => {
    try {
        localStorage.removeItem('authUser');

        dispatch(logoutUserSuccess(true));
    } catch (error) {
        dispatch(apiError(error));
    }
};

export const resetLoginFlag = () => async dispatch => {
    try {
        const response = dispatch(reset_login_flag());
        return response;
    } catch (error) {
        dispatch(apiError(error));
    }
};
